import store from "../store";
import { Howl } from "howler";

export const newVisitorSound = () => {
    if (store.state.auth.user && store.state.auth.user.notificationSettings) {
        let soundFile =
            store.state.auth.user.notificationSettings.find((x) => x.type === "new_visitor")?.soundFile ||
            "new-conversation-default";
        let volume = store.state.auth.user.notificationSettings.find((x) => x.type === "new_visitor")?.audioLevel / 100;
        volume = isNaN(volume) ? 1 : volume;
        const sound = new Howl({
            src: [`./static/media/ogg_folder/${soundFile}.ogg`],
            autoplay: false,
            loop: false,
            volume,
            //onend: () => console.log('newMessageSound Finished!'),
            onplayerror: (ex) => console.error("newMessageSound error!", ex),
        });
        return sound;
    } else {
        return new Howl({
            src: [`./static/media/ogg_folder/new-conversation-default.ogg`],
            autoplay: false,
            loop: false,
            volume: 1,
            //onend: () => console.log('newMessageSound Finished!'),
            onplayerror: (ex) => console.error("newMessageSound error!", ex),
        });
    }
};

export const newConversationSound = () => {
    if (store.state.auth.user && store.state.auth.user.notificationSettings) {
        let soundFile =
            store.state.auth.user.notificationSettings.find((x) => x.type === "new_conversation")?.soundFile ||
            "new-conversation-default";
        let volume =
            store.state.auth.user.notificationSettings.find((x) => x.type === "new_conversation")?.audioLevel / 100;
        volume = isNaN(volume) ? 1 : volume;
        return new Howl({
            src: [`./static/media/ogg_folder/${soundFile}.ogg`],
            autoplay: false,
            loop: false,
            volume,
            //onend:  () => console.log('newConversationSound Finished!'),
            onplayerror: (ex) => console.error("newConversationSound error!", ex),
        });
    } else {
        return new Howl({
            src: [`./static/media/ogg_folder/new-conversation-default.ogg`],
            autoplay: false,
            loop: false,
            volume: 1,
            //onend:  () => console.log('newConversationSound Finished!'),
            onplayerror: (ex) => console.error("newConversationSound error!", ex),
        });
    }
};

export const newMessageSound = () => {
    if (store.state.auth.user && store.state.auth.user.notificationSettings) {
        let soundFile =
            store.state.auth.user.notificationSettings.find((x) => x.type === "new_message")?.soundFile ||
            "new-message-default";
        let volume = store.state.auth.user.notificationSettings.find((x) => x.type === "new_message")?.audioLevel / 100;
        volume = isNaN(volume) ? 1 : volume;
        const sound = new Howl({
            src: [`./static/media/ogg_folder/${soundFile}.ogg`],
            autoplay: false,
            loop: false,
            volume,
            //onend: () => console.log('newMessageSound Finished!'),
            onplayerror: (ex) => console.error("newMessageSound error!", ex),
        });
        return sound;
    } else {
        return new Howl({
            src: [`./static/media/ogg_folder/new-message-default.ogg`],
            autoplay: false,
            loop: false,
            volume: 1,
            //onend: () => console.log('newMessageSound Finished!'),
            onplayerror: (ex) => console.error("newMessageSound error!", ex),
        });
    }
};

export const newPrivateMessage = () => {
    if (store.state.auth.user && store.state.auth.user.notificationSettings) {
        let soundFile =
            store.state.auth.user.notificationSettings.find((x) => x.type === "private_message")?.soundFile ||
            "pm-default";
        let volume =
            store.state.auth.user.notificationSettings.find((x) => x.type === "private_message")?.audioLevel / 100;
        volume = isNaN(volume) ? 1 : volume;
        return new Howl({
            src: [`./static/media/ogg_folder/${soundFile}.ogg`],
            autoplay: false,
            loop: false,
            volume,
            //onend: () => console.log('newPrivateMessage Finished!'),
            onplayerror: (ex) => console.error("newPrivateMessage error!", ex),
        });
    } else {
        return new Howl({
            src: [`./static/media/ogg_folder/pm-default.ogg`],
            autoplay: false,
            loop: false,
            volume: 1,
            //onend: () => console.log('newPrivateMessage Finished!'),
            onplayerror: (ex) => console.error("newPrivateMessage error!", ex),
        });
    }
};

export const defaultNotificationSettings = [
    {
        type: "new_visitor",
        soundFile: "new-conversation-default",
        audioLevel: 100,
        desktopNotification: false,
    },
    {
        type: "new_conversation",
        soundFile: "new-conversation-default",
        audioLevel: 100,
        desktopNotification: false,
    },
    {
        type: "new_message",
        soundFile: "new-message-default",
        audioLevel: 100,
        desktopNotification: false,
    },
    {
        type: "private_message",
        soundFile: "pm-default",
        audioLevel: 100,
        desktopNotification: false,
    },
];
